const invalidEmail = "Please enter a valid email address.";
const emailRequired = "Email address is required.";
const otpRequired = "OTP is required.";
const otpType = "OTP must be a numeric value.";
const confirmPasswordRequired = "Confirm password is required.";
const wrongPasswordFormat = "Wrong password format!";
const confirmAndMainPasswordMatch =
  "Password and confirm password do not match.";
const passwordRequired = "Password is required.";
const passwordRegex =
  "8+ Characters, 1 Special Character, 1 Number, 1 Uppercase and 1 Lowercase Letter.";
const otpCountDownMessage = "Resend OTP in :";
const logOutMessage = "Do you want to logout from the application ?";
const titleRequired = "Please enter a title.";
const descriptionRequired = "Please enter description.";
const dateRequired = "Please enter a valid date.";
const timeRequired = "Please enter a valid time.";
const roomRequired = "Please enter a valid room.";
const unitRequired = "Please enter a valid unit";
const linkRequired = "Please enter a url.";
const invalidLink = "Please enter a valid url.";
const locationRequired = "Please enter location.";
const nameRequired = "Please enter a name.";
const invalidName = "Please enter a valid name.";
const invalidDesignation = "Please enter a valid designation";
const invalidCompanyName = "Please enter a valid company name";
const duplicateAttendee = "Attendee already added.";
const deleteAttendeeMessage = "Do you want to remove ?";
const selectAttendee = "Please select minimum one attendee.";
const selectAction = "Please select minimum one action.";
const invalidFromHour = "Invalid From Hour.";
const invalidToHour = "Invalid To Hour.";
const invalidFromMinute = "Invalid From Minute.";
const invalidToMinute = "Invalid To Minute.";
const invalidDate = "Invalid Date.";
const addAgenda = "Please add agenda.";
const addAttendee = "Please add attendee.";
const invalidTime = "Please add atleast 1 minutes.";
const cancelMeeting = "Do you want to cancel this meeting ?";
const remarksRequired = "Please give remark.";
const meetingCreated = "Meeting created successfully. Please add attendees.";
const invalidFromDate = "From date must be less than To date";
const serverErrorMessage =
  "Sorry, something went wrong. Please try again later.";
const responsiblePersonRequired = "Please add responsible person.";
const priorityRequired = "Please add priority.";
const detailsRequired = "Please enter detail.";
const titleRegexError = "HTML tags are not allowed!";
const descriptionLengthError = "Description length must be between 3 & 30!";
const stringLengthError =
  "Please enter minimum 5 characters & maximum 100 characters!";
const largeStringLengthError =
  "Please enter minimum 3 characters & maximum 500 characters!";
const largeStringLengthErrorForIsComplete =
  "Please enter minimum 3 characters & maximum 250 characters!";
const minuteCreated =
  "Minute created successfully. Check preview section to manage.";
const nameLengthError =
  "Please enter minimum 2 characters & maximum 100 characters!";
const commentsRequired = "Please enter your comments here.";
const notificationAdded = "New Notification.";
const reasonRequired = "Please provide reason.";
const smallStringLengthError =
  "Please enter minimum 3 characters & maximum 100 characters!";
const dateMoreThanMeetingDate =
  "Please give a date grater than or equals to meeting date.";
const rsvpConfirmationMessage = async (rsvp) => {
  return `Your response (${rsvp}) has been updated successfully. Thank you.`;
};
// const invalidInput = "Allowed:(a-z, A-Z, 0-9, space, comma, dash)";
const invalidInput = "Html tags are not allowed";
const characterSizeTitle = "Title must be between 2 - 100 characters";
const characterSizeLocation = "Location must be between 2 - 500 characters";
const organizationNameSize = "Organization must be between 2 - 100 characters";
const invalidReason = "Please enter valid reason (html tags are not allowed)";
const accountIdRequired = "Account Id is required";
const clientIdRequired = "Client Id is required";
const secretTokenRequired = "Secret Token is required";
const htmlTagsNotAllowed = "Html tags are not allowed";
const hostKeyRequired = "Host key is required";
const characterSizeDesignation = "Designation must be between 2-100 characters";
const characterSizeOrg = "Organization must be between 3 - 100 characters";
const titleLengthErrorMessage = "Title must be between 5-200  characters";
const invalidFile = "Unsupported file type. Please upload a JPEG or PNG image.";
const imageDimensionError = "File size exceeds the limit of 200 KB.";
const dropZoneHints =
  "File size max 200 KB, format PNG/JPG/JPEG, dimensions max 220x50px.";
const invalidFollowOnMeetingFromHour =
  "From hour must be greater than or equals to parent meeting To hour";
const invalidFollowOnMeetingDate =
  "Date must be greater than or equals to parent meeting Date";
const invalidFollowOnMeetingFromMinute =
  "From minute must be greater than from parent meeting to minute";
const invalidInputContactPersonName = "Allowed:(a-z, A-Z, space, comma, dash)";
const phoneNoValidation = "Number Must be 10 Digits";
const contactPersonNameValidationCheck =
  "Name Must be Between 2-100 Characters";
const otpBeforeSubmit = "Please verify the OTP before submitting";
const captchaValidation = "Please complete the CAPTCHA verification";
const noInternetErrorMessage =
  "No internet connection. Please check your network and try again.";
const invalidFromMinuteForPreviousMeeting =
  "From time cannot be less than or equal to previous meeting to time";
const invalidFollowOnMeetingDateForPreviousMeeting =
  "Date cannot be less than previous meeting date";
const invalidFollowOnMeetingDateForParentMeeting =
  "Date cannot be less than the parent meeting date";
const invalidFromMinuteForParentMeeting =
  "From time cannot be less than or equal to parent meeting to time";
const insufficientTime = "You don't have Timeline to add more Agendas";
const tooManyAPIRequests = "Too many requests.";
// const fileHints = "Please upload the file according to the provided sample format. Ensure that the sheet contains a maximum of 1000 records when uploading.";
const fileHints = "Please upload the file according to the provided sample format. Ensure that the sheet contains a maximum of <strong>1000</strong> records when uploading.";

const smtpHostRequired = "SMTP Host is required.";
const smtpPortRequired = "SMTP Port is required.";
const invalidSmtpPort = "SMTP Port must be between 1 and 65535.";
const authUser = "Auth User's Email is required.";
const invalidAuthUser = "Please enter a valid email for Auth user.";
const authPass = "Password is required.";
const fromEmail = "From Email is required.";
const invalidFromEmail = "Please enter a valid Email.";
const fromName = "Name is required.";
const invalidSmtpHost = "Please enter a Valid Host Address";
const smtpFromName = "Name must be between 3 - 100 characters";
const userIdRequired = "User id is required";
const tenantIdRequired = "Tenant id is required";
const whatsAppNo = "WhatsApp number must be exactly 10 digits";
module.exports = {
  invalidCompanyName,
  invalidDesignation,
  invalidFromDate,
  smallStringLengthError,
  rsvpConfirmationMessage,
  notificationAdded,
  dateMoreThanMeetingDate,
  commentsRequired,
  nameLengthError,
  reasonRequired,
  minuteCreated,
  descriptionLengthError,
  stringLengthError,
  titleRegexError,
  priorityRequired,
  detailsRequired,
  responsiblePersonRequired,
  serverErrorMessage,
  meetingCreated,
  remarksRequired,
  cancelMeeting,
  addAttendee,
  invalidTime,
  addAgenda,
  invalidDate,
  invalidFromHour,
  invalidToHour,
  invalidFromMinute,
  invalidToMinute,
  deleteAttendeeMessage,
  duplicateAttendee,
  invalidName,
  locationRequired,
  nameRequired,
  invalidLink,
  linkRequired,
  invalidEmail,
  emailRequired,
  confirmPasswordRequired,
  confirmAndMainPasswordMatch,
  otpType,
  otpRequired,
  passwordRequired,
  passwordRegex,
  otpCountDownMessage,
  logOutMessage,
  titleRequired,
  dateRequired,
  timeRequired,
  roomRequired,
  invalidInput,
  characterSizeTitle,
  organizationNameSize,
  characterSizeLocation,
  largeStringLengthError,
  selectAttendee,
  invalidReason,
  unitRequired,
  accountIdRequired,
  clientIdRequired,
  secretTokenRequired,
  htmlTagsNotAllowed,
  hostKeyRequired,
  descriptionRequired,
  characterSizeDesignation,
  characterSizeOrg,
  titleLengthErrorMessage,
  invalidFile,
  imageDimensionError,
  dropZoneHints,
  invalidFollowOnMeetingFromMinute,
  invalidFollowOnMeetingFromHour,
  selectAction,
  invalidInputContactPersonName,
  phoneNoValidation,
  contactPersonNameValidationCheck,
  wrongPasswordFormat,
  invalidFollowOnMeetingDate,
  otpBeforeSubmit,
  captchaValidation,
  largeStringLengthErrorForIsComplete,
  noInternetErrorMessage,
  invalidFromMinuteForPreviousMeeting,
  invalidFollowOnMeetingDateForPreviousMeeting,
  invalidFromMinuteForParentMeeting,
  insufficientTime,
  tooManyAPIRequests,
  fileHints,
  invalidFollowOnMeetingDateForParentMeeting,

  smtpHostRequired,
  smtpFromName,
  smtpPortRequired,
  invalidSmtpPort,
  authUser,
  invalidAuthUser,
  authPass,
  fromEmail,
  invalidFromEmail,
  fromName,
  invalidSmtpHost,

  tenantIdRequired,
  userIdRequired,
  whatsAppNo,
};
